<div id="content">
    <div class="titlebox">Spec Order History</div>
    <div>
        <ag-grid-angular [headerHeight]="35" [rowHeight]="35" style="height: 500px; width: 100%;" class="ag-theme-alpine" [rowData]="rowSpecOrder" [columnDefs]="columnSpecOrder">
        </ag-grid-angular>
    </div>
</div>